import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";

/** Profils altimétriques des circuits (données [distance_km, altitude_m]).
 *  Piloté par le module « Randonnées » (props.profiles issus de GET /randonnees) :
 *  profils calculés côté serveur depuis les GPX, ou hérités quand le GPX ne
 *  porte pas d'altitudes. Aucune donnée n'est codée ici.
 *  props.profiles : [{ id, name, color, data: [[dist, ele], …] }] */

const fmtKm = (v) => `${Number(v).toLocaleString("fr-FR", { maximumFractionDigits: 1 })} km`;

const ProfileTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white border border-bleu/15 rounded-sm px-3 py-2 shadow-md text-sm">
      <p className="font-bold text-bleu">{Math.round(payload[0].payload.ele)} m</p>
      <p className="text-encre/55 text-xs">à {fmtKm(payload[0].payload.dist)} du départ</p>
    </div>
  );
};

const ElevationProfile = ({ profiles = [], visible = "tous", testid = "randonnees-profils" }) => {
  const shown = profiles.filter((c) => visible === "tous" || c.id === visible);
  if (!profiles.length) return null;

  return (
    <div className="mt-4 space-y-6" data-testid={testid}>
      {shown.map((c) => {
        const data = (c.data || []).map(([dist, ele]) => ({ dist, ele }));
        if (!data.length) return null;
        const altMin = Math.floor(Math.min(...data.map((d) => d.ele)) / 20) * 20;
        const altMax = Math.ceil(Math.max(...data.map((d) => d.ele)) / 20) * 20;
        return (
          <div key={c.id} className="bg-white border border-bleu/10 rounded-sm p-5 sm:p-6" data-testid={`${testid}-${c.id}`}>
            <div className="flex flex-wrap items-baseline justify-between gap-2 mb-3">
              <p className="font-heading font-bold text-bleu flex items-center gap-2">
                <span className="inline-block h-1.5 w-8 rounded-full" style={{ background: c.color }} aria-hidden="true" />
                Profil altimétrique — {c.name}
              </p>
              <p className="text-xs text-encre/50">
                {fmtKm(data[data.length - 1].dist)} · altitude {Math.round(data.reduce((a, d) => Math.min(a, d.ele), 9999))} m → {Math.round(data.reduce((a, d) => Math.max(a, d.ele), 0))} m
              </p>
            </div>
            <div className="h-44 sm:h-52">
              <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={data} margin={{ top: 4, right: 8, bottom: 0, left: -12 }}>
                  <CartesianGrid strokeDasharray="3 3" stroke="#173A52" strokeOpacity={0.08} />
                  <XAxis dataKey="dist" type="number" domain={[0, "dataMax"]} tickFormatter={(v) => `${Math.round(v)}`} tick={{ fontSize: 11, fill: "#173A52", opacity: 0.55 }} unit=" km" stroke="#173A52" strokeOpacity={0.2} />
                  <YAxis domain={[altMin, altMax]} tick={{ fontSize: 11, fill: "#173A52", opacity: 0.55 }} unit=" m" stroke="#173A52" strokeOpacity={0.2} width={62} />
                  <Tooltip content={<ProfileTooltip />} />
                  <Area type="monotone" dataKey="ele" stroke={c.color} strokeWidth={2.5} fill={c.color} fillOpacity={0.18} isAnimationActive={false} />
                </AreaChart>
              </ResponsiveContainer>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ElevationProfile;
